import React, { Component } from "react";

import { CButton } from "@coreui/react";
import { connect } from "react-redux";
import {
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active_roles: this.props.general.active_roles,
      selectedYears: [],
      yearsList: [],
      isMultigradeSelected: ""
    };

    this.send = this.send.bind(this);
    this.getGroups = this.getGroups.bind(this);
    this.getRegion = this.getRegion.bind(this);
    this.getSchool = this.getSchool.bind(this);
    this.attState = this.attState.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleToggleAll = this.handleToggleAll.bind(this);
  }

  componentDidMount() {
    this.getGroups();
    this.getDateList();
  }

  getDateList() {
    const currentYear = new Date().getFullYear();

    if (currentYear > 2022) {
      const generatedYears = Array.from(
        { length: currentYear + 1 - 2022 },
        (_, i) => i + 2022
      );

      this.setState({
        yearsList: generatedYears,
        selectedYears: generatedYears // NOVO: Todos os anos já vêm selecionados
      });
    }
  }

  handleToggleAll(e) {
    const isChecked = e.target.checked;
    this.setState(prevState => ({
      // Se marcou "Todos", copia a lista inteira. Se desmarcou, limpa o array.
      selectedYears: isChecked ? [...prevState.yearsList] : []
    }));
  }

  getGroups() {
    if (!this.state.groupSearched)
      axios
        .get(`${URL.api}access/group/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              this.setState(
                {
                  group: resp.data.data,
                  groupSearched: true
                },
                () => {
                  if (this.props.general.active_roles.group_id != null) {
                    this.attState({
                      target: {
                        name: "group",
                        value: this.props.general.active_roles.group_id
                      }
                    });
                  }
                }
              );
            }
          },
          error => {
            if (error.response.statusText === "Unauthorized") {
              this.props.logout(this.props.user.token);
            }
          }
        );
  }

  getRegion() {
    axios
      .get(
        `${URL.api}access/region/listRegionFilter/${this.state.groupSelected}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(
              {
                region: resp.data.data
              },
              () => {
                if (this.props.general.active_roles.region_id != null) {
                  this.attState({
                    target: {
                      name: "region",
                      value: this.props.general.active_roles.region_id
                    }
                  });
                }
              }
            );
          }
        },
        error => {
          if (error.response.statusText === "Unauthorized") {
            this.props.logout(this.props.user.token);
          }
        }
      );
  }

  getSchool() {
    axios
      .get(
        `${URL.api}access/school/listSchoolFilter/${this.state.groupSelected}/${this.state.regionSelected}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(
              {
                school: resp.data.data
              },
              () => {
                if (this.props.general.active_roles.school_id != null) {
                  this.attState({
                    target: {
                      name: "school",
                      value: this.props.general.active_roles.school_id
                    }
                  });
                }
              }
            );
          }
        },
        error => {
          if (error.response.statusText === "Unauthorized") {
            this.props.logout(this.props.user.token);
          }
        }
      );
  }

  attState(e) {
    const { name } = e.target;
    const value =
      name === "isMultigrade" ? e.target.value : parseInt(e.target.value);
    if (this.props.type === "hierarchy") {
      if (name === "group") {
        this.setState(
          {
            groupSelected: value,
            regionSelected: null,
            schoolSelected: null
          },
          () => {
            if (this.props.region) {
              this.getRegion();
            }
          }
        );
      }
      if (name === "region") {
        this.setState(
          {
            regionSelected: value,
            schoolSelected: null
          },
          () => {
            if (this.props.school) {
              this.getSchool();
            }
          }
        );
      }
      if (name === "school") {
        this.setState({
          schoolSelected: value
        });
      }
    }

    if (name === "isMultigrade") {
      let isMultigrade = null;
      if (value === "true") isMultigrade = true;
      else if (value === "false") isMultigrade = false;
      this.setState({ isMultigradeSelected: isMultigrade });
    }
  }

  handleYearChange(e) {
    const year = parseInt(e.target.value, 10);
    const isChecked = e.target.checked;

    this.setState(prevState => {
      if (isChecked) {
        return { selectedYears: [...prevState.selectedYears, year] };
      }
      return { selectedYears: prevState.selectedYears.filter(y => y !== year) };
    });
  }

  send() {
    if (this.props.type === "hierarchy") {
      let group = null;
      let region = null;
      let school = null;
      let years = [];
      let isMultigrade = null;

      if (this.props.group) {
        group = this.state.groupSelected;
      }
      if (this.props.group) {
        region = this.state.regionSelected;
      }
      if (this.props.school && this.state.schoolSelected) {
        school = this.state.schoolSelected;
      }
      if (this.props.years) {
        years = this.state.selectedYears;
      }

      if (this.props.multigradeToggle) {
        isMultigrade = this.state.isMultigradeSelected;
      }

      this.props.action("", group, region, school, years, isMultigrade);
    }
  }

  render() {
    if (this.props.general.active_roles !== this.state.active_roles) {
      this.componentDidMount();
      this.setState({ active_roles: this.props.general.active_roles });
    }

    return (
      <>
        {this.props.years &&
          this.state.yearsList &&
          this.state.yearsList.length > 0 && (
            <FormGroup className="ml-2">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <span>Anos</span>
                  </InputGroupText>
                </InputGroupAddon>

                <UncontrolledDropdown style={{ flex: "1 1 auto" }}>
                  <DropdownToggle
                    caret
                    className="form-control d-flex justify-content-between align-items-center bg-white text-dark"
                    style={{ cursor: "pointer", borderLeft: "none" }}
                  >
                    {/* Texto dinâmico: Mostra "Todos", "Nenhum", ou os anos selecionados (ex: "2023, 2024") */}
                    <span
                      className="text-truncate"
                      style={{ maxWidth: "120px" }}
                    >
                      {this.state.selectedYears.length ===
                      this.state.yearsList.length
                        ? "Todos"
                        : this.state.selectedYears.length === 0
                        ? "Selecione..."
                        : this.state.selectedYears.join(", ")}
                    </span>
                  </DropdownToggle>

                  <DropdownMenu style={{ minWidth: "100%", padding: "10px" }}>
                    {/* Opção TODOS */}
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        id="year-all"
                        checked={
                          this.state.selectedYears.length ===
                          this.state.yearsList.length
                        }
                        onChange={this.handleToggleAll}
                      />
                      <Label
                        check
                        htmlFor="year-all"
                        className="font-weight-bold"
                        style={{ cursor: "pointer" }}
                      >
                        Todos
                      </Label>
                    </FormGroup>

                    <div className="dropdown-divider"></div>

                    {/* Listagem Individual */}
                    {this.state.yearsList.map(year => (
                      <FormGroup check key={year}>
                        <Input
                          type="checkbox"
                          id={`year-${year}`}
                          value={year}
                          checked={this.state.selectedYears.includes(year)}
                          onChange={this.handleYearChange}
                        />
                        <Label
                          check
                          htmlFor={`year-${year}`}
                          style={{ cursor: "pointer" }}
                        >
                          {year}
                        </Label>
                      </FormGroup>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </InputGroup>
            </FormGroup>
          )}

        {this.props.multigradeToggle && (
          <FormGroup className="ml-2">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span htmlFor="isMultigrade">Tipo de Turma</span>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                name="isMultigrade"
                type="select"
                value={
                  this.state.isMultigradeSelected !== null
                    ? String(this.state.isMultigradeSelected)
                    : ""
                }
                onChange={this.attState}
              >
                <option value="">Todas</option>
                <option value="false">Seriada</option>
                <option value="true">Multisseriada</option>
              </Input>
            </InputGroup>
          </FormGroup>
        )}

        {this.state.group && this.props.group && (
          <FormGroup
            className="ml-2"
            hidden={this.props.general.active_roles.group_id !== null}
          >
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span htmlFor="group">Grupo</span>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                name="group"
                type="select"
                value={this.state.groupSelected ? this.state.groupSelected : 0}
                onChange={this.attState}
              >
                <>
                  <option key="0" value="0">
                    Selecione
                  </option>
                  {this.state.group.map((elem, idx) => (
                    <option key={idx + 1} value={elem.id}>
                      {elem.name}
                    </option>
                  ))}
                </>
              </Input>
            </InputGroup>
          </FormGroup>
        )}
        {this.state.region && this.props.region && (
          <FormGroup
            className="ml-2"
            hidden={this.props.general.active_roles.region_id !== null}
          >
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span htmlFor="region">Região</span>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                name="region"
                type="select"
                value={
                  this.state.regionSelected ? this.state.regionSelected : 0
                }
                onChange={this.attState}
              >
                <>
                  <option key="0" value="0">
                    Selecione
                  </option>
                  {this.state.region.map((elem, idx) => (
                    <option key={idx + 1} value={elem.id}>
                      {elem.name}
                    </option>
                  ))}
                </>
              </Input>
            </InputGroup>
          </FormGroup>
        )}
        {this.state.school && this.props.school && (
          <FormGroup
            className="ml-2"
            hidden={this.props.general.active_roles.school_id !== null}
          >
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span htmlFor="school">Escola</span>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                name="school"
                type="select"
                value={
                  this.state.schoolSelected ? this.state.schoolSelected : 0
                }
                onChange={this.attState}
              >
                <>
                  <option key="0" value="0">
                    Selecione
                  </option>
                  {this.state.school.map((elem, idx) => (
                    <option key={idx + 1} value={elem.id}>
                      {elem.name}
                    </option>
                  ))}
                </>
              </Input>
            </InputGroup>
          </FormGroup>
        )}
        <FormGroup className="ml-auto">
          <CButton
            color="primary"
            onClick={this.send}
            // hidden={
            //   this.props.general.active_roles.group_id === null &&
            //   this.props.general.active_roles.region_id === null &&
            //   this.props.general.active_roles.school_id === null
            // }
          >
            <i className="fa fa-search mr-2"></i>Pesquisar
          </CButton>
        </FormGroup>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
